import { render, staticRenderFns } from "./RecommendedApps.vue?vue&type=template&id=fc87b07e&scoped=true&"
import script from "./RecommendedApps.vue?vue&type=script&lang=js&"
export * from "./RecommendedApps.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedApps.vue?vue&type=style&index=0&id=fc87b07e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc87b07e",
  null
  
)

export default component.exports